
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M63.16 51.186a.367.367 0 01-.362.361H7.52a.366.366 0 01-.362-.361v-41.9c0-.195.165-.36.362-.36h55.277c.196 0 .361.165.361.36v41.9zM30.277 60.76h9.763v-7.303h-9.763v7.303zm32.52-53.744H7.52a2.273 2.273 0 00-2.27 2.27v41.9a2.273 2.273 0 002.27 2.27h20.848v7.304h-9.003a.954.954 0 100 1.91h31.586a.955.955 0 000-1.91H41.95v-7.304h20.848a2.273 2.273 0 002.27-2.27v-41.9a2.273 2.273 0 00-2.27-2.27z"}}),_c('path',{attrs:{"d":"M15.167 42.805V37.22h39.959v5.586a.14.14 0 01-.14.141H15.307a.141.141 0 01-.14-.14zm0-20.4v-3.818a.14.14 0 01.141-.14h39.677a.14.14 0 01.14.14V35.31H15.168V22.405zm-1.909 5.764v14.636c0 1.13.92 2.05 2.05 2.05h39.677c1.13 0 2.05-.92 2.05-2.05V18.587c0-1.13-.92-2.05-2.05-2.05H15.308c-1.13 0-2.05.92-2.05 2.05v9.582z"}}),_c('path',{attrs:{"d":"M52.262 39.128H18.031a.955.955 0 000 1.91h34.231a.955.955 0 000-1.91M31.915 24.146l5.326 2.732-5.326 2.733v-5.465zm-1.452 7.842a.96.96 0 00.933.035l8.372-4.295a.956.956 0 000-1.7l-8.372-4.295a.955.955 0 00-1.39.85v8.59c0 .333.173.642.457.815z"}})])])
          )
        }
      }
    